var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { CollaboratorTicket } from '../Reports/Model';
import { api } from '../../helpers/Api';
import { RenderTicket } from '../../components/Ticket/Ticket';
import { Col, Row } from 'reactstrap';
import { BlockLogo } from '../../components/Ticket/Blocks/BlockLogo';
import { Align, FontSize } from '../ReceiptLayouts/Model';
import { BlockWeb } from '../../components/Ticket/Blocks/BlockWeb';
import { BlockUser } from '../../components/Ticket/Blocks/BlockUser';
import { BlockDate } from '../../components/Ticket/Blocks/BlockDate';
import { BlockSeparator } from '../../components/Ticket/Blocks/BlockSeparator';
import { Texto } from '../../components/Ticket/Texto';
import { BlockDataContact } from '../../components/Ticket/Blocks/BlockDataContact';
import { BlockService } from '../../components/Ticket/Blocks/BlockService';
import { BlockCheckins } from '../../components/Ticket/Blocks/BlockCheckins';
import { BlockExtras } from '../../components/Ticket/Blocks/BlockExtras';
import { BlockPayments } from '../../components/Ticket/Blocks/BlockPayments';
import { BlockQR } from '../../components/Ticket/Blocks/BlockQR';
import { RenderExpiration } from '../../components/Ticket/Expiration';
export var Cart = function (props) {
    var _a = props.match.params, client = _a.client, carttoken = _a.carttoken;
    console.log('client', client);
    console.log('carttoken', carttoken);
    var _b = useState(false), loaded = _b[0], setLoaded = _b[1];
    var _c = useState(null), cart = _c[0], setCart = _c[1];
    var _d = useState(true), hideModalDatePicker = _d[0], setHideModalDatePicker = _d[1];
    useEffect(function () {
        if (!cart) {
            api.get("getcart/".concat(client, "/").concat(carttoken))
                .then(function (result) {
                console.log('result: ', result);
                result.tickets = __spreadArray(__spreadArray([], result.tickets, true), result.tickets, true);
                result.tickets[1].numero = result.tickets[1].numero + 'ALELU';
                setCart(result);
            })
                .catch(function (error) {
                console.log('error: ', error);
                setCart(null);
            });
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        !cart &&
            React.createElement("div", null, 'loading'),
        cart &&
            React.createElement("div", { style: { display: 'inline-block' } }, cart.tickets.map(function (ticket, index) {
                return React.createElement("div", { key: ticket.numero },
                    React.createElement(RenderTicket, { ticket: ticket, showPaymentMethod: ticket.totalDue > 0, hideModalDatePicker: hideModalDatePicker, onClick: function () { }, onPay: function () { } }),
                    index < cart.tickets.length - 1 &&
                        React.createElement("hr", null));
            }))));
};
var TicketDetail = function (_a) {
    var ticket = _a.ticket;
    return (React.createElement("div", { style: { width: '100%' } },
        React.createElement(Row, { style: { width: '100%' } },
            React.createElement(Col, null,
                React.createElement(Row, null,
                    React.createElement(Col, { sm: 4 },
                        React.createElement(BlockLogo, { image: ticket.image, align: Align.Center }),
                        ticket.cartToken ?
                            React.createElement(BlockWeb, { collaboratorName: ticket instanceof CollaboratorTicket ? ticket.collaboratorName : undefined })
                            :
                                React.createElement(BlockUser, { user: ticket.username, collaboratorName: ticket instanceof CollaboratorTicket ? ticket.collaboratorName : undefined }),
                        React.createElement(BlockDate, { fecha: ticket.datecheck })),
                    React.createElement(Col, { sm: 8 },
                        ticket.numberSI && React.createElement(Texto, { texto: 'Factura Simplificada nº', fontSize: FontSize.big }),
                        React.createElement("h3", null, ticket.numberSI ? ticket.numberSI : 'TARJETA DE EMBARQUE'))),
                React.createElement(Row, null,
                    React.createElement(Col, null,
                        React.createElement(BlockDataContact, { ticket: ticket })))),
            React.createElement(Col, null,
                React.createElement("div", null,
                    React.createElement(BlockService, { operationline: ticket.operationLineName, stretchName: ticket.stretchName, origin: ticket.origin, destination: ticket.destination }),
                    React.createElement(BlockSeparator, null),
                    React.createElement(BlockCheckins, { lines: ticket.lines }),
                    React.createElement(BlockSeparator, null),
                    React.createElement(BlockExtras, { item: ticket }),
                    React.createElement(BlockPayments, { item: ticket }))),
            React.createElement(Col, { className: "justify-content-center" },
                React.createElement("div", null,
                    React.createElement(BlockQR, { ticket: ticket }),
                    React.createElement(RenderExpiration, { item: ticket }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/CartTicketResult/index.tsx
// module id = 1637
// module chunks = 0